var content = 'fx_e395032e_168eayi0';

export { content };
//# sourceMappingURL=hoverPopover.vanilla.mjs.map
